import { faCheck } from "@fortawesome/pro-regular-svg-icons/faCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "../assets/scss/components/_promo-codes.scss";
import { useCartStore } from "../stores/CartStore";
import { usePromoStore } from "../stores/PromoStore";

export const PromoCodes = () => {
	const { promoInfo } = usePromoStore((state) => state);

	const { discountCode, SetDiscountCode, ApplyDiscount } = useCartStore(
		({ discountCode, SetDiscountCode, ApplyDiscount }) => {
			return { discountCode, SetDiscountCode, ApplyDiscount };
		},
	);

	return (
		promoInfo &&
		Object.keys(promoInfo).length > 0 && (
			<div className="promo-codes">
				{Object.keys(promoInfo).map((key) => {
					return (
						<div
							key={key}
							className={`promo-code ${discountCode === promoInfo[key].coupon_code ? "active" : ""}`}
							onClick={() => {
								console.log("click");
								SetDiscountCode(promoInfo[key].coupon_code);
								ApplyDiscount(promoInfo[key].coupon_code);
							}}
						>
							{discountCode === promoInfo[key].coupon_code && <FontAwesomeIcon icon={faCheck} />}
							<span>Your {key.replace("-", " ")} Code: </span> {promoInfo[key].coupon_code}
						</div>
					);
				})}
			</div>
		)
	);
};
